<h1 mat-dialog-title>Notas</h1>
<div mat-dialog-content>
  <p>Esta seguro que quiere eliminar la nota?</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">NO</button>
  <button mat-button [mat-dialog-close]="true"  cdkFocusInitial>SI</button>
</div>
